import Vue from 'vue'
import App from './App.vue'
import './assets/base.less'
import './assets/js/rem.js'
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
